<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>


<div class="notifications-container">
  @for (notification of filteredNotifications; track notification) {
    <div class="col-lg-4 col-md-6 notification-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ notification.title }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>{{ notification.createdOn | date: 'd.M.yyyy.' }}</p>
          <div>
            <div>{{ notification.message }}</div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj obavijest" (click)="viewNotification(notification)">
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
